import { createDataState } from "@/utils";
import { TARGET_DATA, anxietyDataFields } from "@/config";

// Default state
const defaultState = () => {
  return {
    [TARGET_DATA.anxiety]: createDataState(anxietyDataFields, {
      choose_comforts: [],
      choose_fears: [],
      choose_feeling: "",
    }),
  };
};

// State object
const state = defaultState();

// Getter functions
const getters = {
  getAnxietyData(state) {
    return state[TARGET_DATA.anxiety];
  },
};

// Actions
const actions = {
  setData({ commit }, data) {
    commit("SET_FORM_DATA", data);
  },
  resetState({ commit }) {
    commit("RESET_STATE");
  },
};

// Mutations
const mutations = {
  SET_FORM_DATA(state, { fieldName, data }) {
    state[TARGET_DATA.anxiety][fieldName] = data;
  },
  RESET_STATE(state) {
    Object.assign(state, defaultState());
  },
};

export default {
  name: "AnxietyModule",
  dynamic: true,
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
